import { Box, Text } from '@nimbus-ds/components';
import { ImageItemStratusSkeleton } from 'commons/components';

export function CustomerSubscriptionsProductsCardSkeleton(): JSX.Element | null {
  return (
    <div className="stratus--orders-list-products-mobile">
      <ImageItemStratusSkeleton
        imageWidth="48px"
        headerRight={<Text.Skeleton />}
      >
        <Box display="flex" flexDirection="column">
          <Text.Skeleton fontSize="caption" />
          <Text.Skeleton fontSize="caption" />
        </Box>
      </ImageItemStratusSkeleton>
    </div>
  );
}
